export const PROCESSING_STATUS = 'processing';
export const UNRECOGNIZED_STATUS = 'unrecognized';
export const PARTIALLY_RECOGNIZED_STATUS = 'partially_recognized';
export const UPLOAD_ERROR_STATUS = 'upload_error';
export const RECOGNITION_ERROR_STATUS = 'recognition_error';
export const EMPTY_STATUS = 'empty';
export const SUCCESS_STATUS = 'success';
export const UPLOADED_STATUS = 'uploaded';
export const FAILED_STATUS = 'failed';